const NilReport  = () =>
{
    return(
        <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.375 30.625V25.375M20.125 30.625V14.875M28.875 30.625V23.625" stroke="#2F3237" strokeOpacity="0.4" strokeWidth="1.5" strokeLinecap="round"/>
<path d="M37.625 9.625C37.625 12.5245 35.2746 14.875 32.375 14.875C29.4754 14.875 27.125 12.5245 27.125 9.625C27.125 6.72551 29.4754 4.375 32.375 4.375C35.2746 4.375 37.625 6.72551 37.625 9.625Z" stroke="#2F3237" strokeOpacity="0.4" strokeWidth="1.5"/>
<path d="M37.6171 19.25C37.6171 19.25 37.625 19.8441 37.625 21C37.625 28.8372 37.625 32.7556 35.1904 35.1904C32.7556 37.625 28.837 37.625 21 37.625C13.1629 37.625 9.24436 37.625 6.80967 35.1904C4.375 32.7556 4.375 28.8372 4.375 21C4.375 13.163 4.375 9.24441 6.80967 6.80972C9.24436 4.37505 13.1629 4.37505 21 4.37505L22.75 4.375" stroke="#2F3237" strokeOpacity="0.4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

    )
}

export default NilReport;